import { BRAND } from "./brand";

export const getSupportUrl = (email?: string): string => {
    const supportParams = email ? `?email=${encodeURIComponent(email)}` : "";
    return `${BRAND.supportUrl}/support${supportParams}`;
}
